import React from 'react'
import Navbar from '../components/Home/Navbar/Navbar'
import Footer from '../components/Home/Footer/Footer'
import Pressurewashing from '../components/Services06/Pressurewashing'
import PressureWashingDetails from '../components/Services06/Pressurewashingdetails'

const Pressurewashingpage = () => {
    return (
        <div>
        <Navbar/>
        <main>
        <Pressurewashing/>
        <PressureWashingDetails/>
        </main>
       


        <Footer/>

        </div>
    )
}

export default Pressurewashingpage
